import React, { Component } from 'react'
import { connect } from "react-redux";
import BasketContainer from '../../common/transactions/BasketContainer'

class BasketPage extends Component {
    render() {
        const { params, location, firstLoginToBundles } = this.props;

        return (
            <article className="container basket-body">
                <main className={ firstLoginToBundles ? 'first-login-basket-view' : '' }>
                    <section className="row">
                        <div className="col-xs-12 text-center">
                            <h1 className="h1">Your Basket</h1>
                            <hr/>
                        </div>
                        <BasketContainer location={ location } />
                    </section>
                </main>
            </article>
        );
    };
}

const mapStateToProps = state => {
    return {
        firstLoginToBundles: state.authentication.firstLoginToBundles,
    };
};

export default connect( mapStateToProps, null )( BasketPage );



// WEBPACK FOOTER //
// src/client/components/site/pages/BasketPage.js